'use client';

import { type Nullable } from '@libs/core';
import type {
    AddToOrderRecurringResponse,
    AddToOrderResponse,
    PostOrdergrooveAddSubscription,
} from '@libs/order-groove';
import { getNextApiRoute, typedFetch } from '@libs/common-next';
import { HttpMethod } from '@libs/core';

type HandleAddToExistingSubscription = (
    props: PostOrdergrooveAddSubscription
) => Promise<Nullable<AddToOrderResponse | AddToOrderRecurringResponse>>;

export const handleAddToExistingSubscription: HandleAddToExistingSubscription =
    async (props: PostOrdergrooveAddSubscription) => {
        if ((props.quantity ?? 0) > 0) {
            const url = getNextApiRoute('ordergroove');
            return await typedFetch(url, {
                method: HttpMethod.POST,
                body: JSON.stringify(props),
                headers: {
                    'content-type': 'application/json',
                },
            });
        }

        return null;
    };
